module.exports = __webpack_public_path__ + "3c08669e3b8819de5c083536b6883485.pdf";